import { render, staticRenderFns } from "./Connect4Piece.vue?vue&type=template&id=392bef06&scoped=true&"
import script from "./Connect4Piece.vue?vue&type=script&lang=js&"
export * from "./Connect4Piece.vue?vue&type=script&lang=js&"
import style0 from "./Connect4Piece.vue?vue&type=style&index=0&id=392bef06&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "392bef06",
  null
  
)

export default component.exports